"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on 2019-04-11
 */

var immutable_1 = require("immutable");

var PriceFormulas_1 = require("../../../core/model/math/PriceFormulas");

var utils_1 = require("../../../core/utils");

var SelloutImpactRecordSums_1 = require("../../model/sellout/SelloutImpactRecordSums");

var SelloutImpactRecordSumsConverter_1 = require("./SelloutImpactRecordSumsConverter");
/**
 * @author Radek Beran
 */


var SelloutImpactRecordSumsConverterImpl =
/*#__PURE__*/
function (_SelloutImpactRecordS) {
  _inherits(SelloutImpactRecordSumsConverterImpl, _SelloutImpactRecordS);

  function SelloutImpactRecordSumsConverterImpl() {
    _classCallCheck(this, SelloutImpactRecordSumsConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactRecordSumsConverterImpl).apply(this, arguments));
  }

  _createClass(SelloutImpactRecordSumsConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      return new SelloutImpactRecordSums_1.SelloutImpactRecordSums(conversions.documentToClassId(source), conversions.toClassReferenceId(source.releaseId), conversions.toClassReferenceId(source.categoryId), !utils_1.Utils.isValueMissing(source.reopen) ? SelloutImpactRecordSums_1.SelloutImpactRecordSums.schema.reopen.valueOfField(source) : null, SelloutImpactRecordSums_1.SelloutImpactRecordSums.schema.selloutProductsCount.valueOfField(source), utils_1.Utils.isValueMissing(source.sites) ? immutable_1.Set.of() : immutable_1.Set(source.sites), SelloutImpactRecordSums_1.SelloutImpactRecordSums.schema.priceChangesCount.valueOfField(source), conversions.toBigNumber(source.discountPercentUpperSum), conversions.toBigNumber(source.discountPercentWeightSum), utils_1.Utils.isValueMissing(source.marginOldUpperSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.marginOldUpperSum), utils_1.Utils.isValueMissing(source.marginOldWeightSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.marginOldWeightSum), utils_1.Utils.isValueMissing(source.marginNewUpperSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.marginNewUpperSum), utils_1.Utils.isValueMissing(source.marginChangeUpperSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.marginChangeUpperSum), conversions.toBigNumber(source.marginChangePercentUpperSum), conversions.toBigNumber(source.marginChangePercentWeightSum), utils_1.Utils.isValueMissing(source.profitOldUpperSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.profitOldUpperSum), utils_1.Utils.isValueMissing(source.profitOldWeightSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.profitOldWeightSum), utils_1.Utils.isValueMissing(source.profitNewUpperSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.profitNewUpperSum), utils_1.Utils.isValueMissing(source.profitNewWeightSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.profitNewWeightSum), utils_1.Utils.isValueMissing(source.profitImpactUpperSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.profitImpactUpperSum), utils_1.Utils.isValueMissing(source.profitImpactPercentUpperSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.profitImpactPercentUpperSum), utils_1.Utils.isValueMissing(source.profitImpactPercentWeightSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.profitImpactPercentWeightSum), utils_1.Utils.isValueMissing(source.minPriceChangeInPercentUpperSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.minPriceChangeInPercentUpperSum), utils_1.Utils.isValueMissing(source.minPriceChangeInPercentWeightSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.minPriceChangeInPercentWeightSum), utils_1.Utils.isValueMissing(source.maxPriceChangeInPercentUpperSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.maxPriceChangeInPercentUpperSum), utils_1.Utils.isValueMissing(source.maxPriceChangeInPercentWeightSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.maxPriceChangeInPercentWeightSum), conversions.toBigNumber(source.minMarginChangeInPercentUpperSum), conversions.toBigNumber(source.minMarginChangeInPercentWeightSum), conversions.toBigNumber(source.availableSupplyPriceSum), conversions.toBigNumber(source.availableSupplySum), conversions.toBigNumber(source.availableSupplyBeforeRepricingPriceSum), conversions.toBigNumber(source.availableSupplyBeforeRepricingSum), conversions.toBigNumber(source.deadstockProvisionDiscountPercentUpperSum), conversions.toBigNumber(source.deadstockProvisionDiscountPercentWeightSum), conversions.toBigNumber(source.deadstockProvisionUpperSum), conversions.toBigNumber(source.deadstockProvisionWeightSum), conversions.toBigNumber(source.deadstockInvestmentUpperSum), conversions.toBigNumber(source.deadstockInvestmentWeightSum), conversions.toBigNumber(source.deadstockImpactUpperSum), conversions.toBigNumber(source.deadstockImpactWeightSum), utils_1.Utils.isValueMissing(source.estimationInPercentSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.estimationInPercentSum), utils_1.Utils.isValueMissing(source.estimationInPercentWeightSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.estimationInPercentWeightSum), utils_1.Utils.isValueMissing(source.salesVolumeOldSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.salesVolumeOldSum), utils_1.Utils.isValueMissing(source.salesVolumeNewSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.salesVolumeNewSum), utils_1.Utils.isValueMissing(source.revenueOldSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.revenueOldSum), utils_1.Utils.isValueMissing(source.revenueNewSum) ? PriceFormulas_1.PriceFormulas.ZERO // for backward compatibility only, can be removed in production version
      : conversions.toBigNumber(source.revenueNewSum));
    }
  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var doc = {};
      doc = Object.assign(doc, conversions.classToDocumentId(source));
      doc = Object.assign(doc, {
        releaseId: conversions.toDocumentReferenceId(source.releaseId),
        categoryId: conversions.toDocumentReferenceId(source.categoryId)
      });

      if (!utils_1.Utils.isValueMissing(source.reopen)) {
        doc.reopen = source.reopen;
      }

      doc = Object.assign(doc, {
        selloutProductsCount: source.selloutProductsCount
      });
      doc = Object.assign(doc, {
        sites: source.sites.toArray()
      });
      doc = Object.assign(doc, {
        priceChangesCount: source.priceChangesCount
      });
      doc = Object.assign(doc, {
        discountPercentUpperSum: conversions.fromBigNumber(source.discountPercentUpperSum)
      });
      doc = Object.assign(doc, {
        discountPercentWeightSum: conversions.fromBigNumber(source.discountPercentWeightSum)
      });
      doc = Object.assign(doc, {
        marginOldUpperSum: conversions.fromBigNumber(source.marginOldUpperSum)
      });
      doc = Object.assign(doc, {
        marginOldWeightSum: conversions.fromBigNumber(source.marginOldWeightSum)
      });
      doc = Object.assign(doc, {
        marginNewUpperSum: conversions.fromBigNumber(source.marginNewUpperSum)
      });
      doc = Object.assign(doc, {
        marginChangeUpperSum: conversions.fromBigNumber(source.marginChangeUpperSum)
      });
      doc = Object.assign(doc, {
        marginChangePercentUpperSum: conversions.fromBigNumber(source.marginChangePercentUpperSum)
      });
      doc = Object.assign(doc, {
        marginChangePercentWeightSum: conversions.fromBigNumber(source.marginChangePercentWeightSum)
      });
      doc = Object.assign(doc, {
        profitOldUpperSum: conversions.fromBigNumber(source.profitOldUpperSum)
      });
      doc = Object.assign(doc, {
        profitOldWeightSum: conversions.fromBigNumber(source.profitOldWeightSum)
      });
      doc = Object.assign(doc, {
        profitNewUpperSum: conversions.fromBigNumber(source.profitNewUpperSum)
      });
      doc = Object.assign(doc, {
        profitNewWeightSum: conversions.fromBigNumber(source.profitNewWeightSum)
      });
      doc = Object.assign(doc, {
        profitImpactUpperSum: conversions.fromBigNumber(source.profitImpactUpperSum)
      });
      doc = Object.assign(doc, {
        profitImpactPercentUpperSum: conversions.fromBigNumber(source.profitImpactPercentUpperSum)
      });
      doc = Object.assign(doc, {
        profitImpactPercentWeightSum: conversions.fromBigNumber(source.profitImpactPercentWeightSum)
      });
      doc = Object.assign(doc, {
        minPriceChangeInPercentUpperSum: conversions.fromBigNumber(source.minPriceChangeInPercentUpperSum)
      });
      doc = Object.assign(doc, {
        minPriceChangeInPercentWeightSum: conversions.fromBigNumber(source.minPriceChangeInPercentWeightSum)
      });
      doc = Object.assign(doc, {
        maxPriceChangeInPercentUpperSum: conversions.fromBigNumber(source.maxPriceChangeInPercentUpperSum)
      });
      doc = Object.assign(doc, {
        maxPriceChangeInPercentWeightSum: conversions.fromBigNumber(source.maxPriceChangeInPercentWeightSum)
      });
      doc = Object.assign(doc, {
        minMarginChangeInPercentUpperSum: conversions.fromBigNumber(source.minMarginChangeInPercentUpperSum)
      });
      doc = Object.assign(doc, {
        minMarginChangeInPercentWeightSum: conversions.fromBigNumber(source.minMarginChangeInPercentWeightSum)
      });
      doc = Object.assign(doc, {
        availableSupplyPriceSum: conversions.fromBigNumber(source.availableSupplyPriceSum)
      });
      doc = Object.assign(doc, {
        availableSupplySum: conversions.fromBigNumber(source.availableSupplySum)
      });
      doc = Object.assign(doc, {
        availableSupplyBeforeRepricingPriceSum: conversions.fromBigNumber(source.availableSupplyBeforeRepricingPriceSum)
      });
      doc = Object.assign(doc, {
        availableSupplyBeforeRepricingSum: conversions.fromBigNumber(source.availableSupplyBeforeRepricingSum)
      });
      doc = Object.assign(doc, {
        deadstockProvisionDiscountPercentUpperSum: conversions.fromBigNumber(source.deadstockProvisionDiscountPercentUpperSum)
      });
      doc = Object.assign(doc, {
        deadstockProvisionDiscountPercentWeightSum: conversions.fromBigNumber(source.deadstockProvisionDiscountPercentWeightSum)
      });
      doc = Object.assign(doc, {
        deadstockProvisionUpperSum: conversions.fromBigNumber(source.deadstockProvisionUpperSum)
      });
      doc = Object.assign(doc, {
        deadstockProvisionWeightSum: conversions.fromBigNumber(source.deadstockProvisionWeightSum)
      });
      doc = Object.assign(doc, {
        deadstockInvestmentUpperSum: conversions.fromBigNumber(source.deadstockInvestmentUpperSum)
      });
      doc = Object.assign(doc, {
        deadstockInvestmentWeightSum: conversions.fromBigNumber(source.deadstockInvestmentWeightSum)
      });
      doc = Object.assign(doc, {
        deadstockImpactUpperSum: conversions.fromBigNumber(source.deadstockImpactUpperSum)
      });
      doc = Object.assign(doc, {
        deadstockImpactWeightSum: conversions.fromBigNumber(source.deadstockImpactWeightSum)
      });
      doc = Object.assign(doc, {
        estimationInPercentSum: conversions.fromBigNumber(source.estimationInPercentSum)
      });
      doc = Object.assign(doc, {
        estimationInPercentWeightSum: conversions.fromBigNumber(source.estimationInPercentWeightSum)
      });
      doc = Object.assign(doc, {
        salesVolumeOldSum: conversions.fromBigNumber(source.salesVolumeOldSum)
      });
      doc = Object.assign(doc, {
        salesVolumeNewSum: conversions.fromBigNumber(source.salesVolumeNewSum)
      });
      doc = Object.assign(doc, {
        revenueOldSum: conversions.fromBigNumber(source.revenueOldSum)
      });
      doc = Object.assign(doc, {
        revenueNewSum: conversions.fromBigNumber(source.revenueNewSum)
      });
      return doc;
    }
  }]);

  return SelloutImpactRecordSumsConverterImpl;
}(SelloutImpactRecordSumsConverter_1.SelloutImpactRecordSumsConverter);

exports.SelloutImpactRecordSumsConverterImpl = SelloutImpactRecordSumsConverterImpl;